export let dataProps = {
    key: 0,
    id: 0,
    document_title: '',
    attachment: '',
    expiration_date: new Date(),
    reminder_date: new Date(),
    enable_reminder: false
}


// WEBPACK FOOTER //
// ./src/store/modules/document/properties.js